import { SET_APP } from './actionTypes'

interface SetAppAction {
  type: typeof SET_APP, 
  payload: object | null
}

export enum EAppVersion {
  a = 'a',
  b = 'b'
}

export interface AppState {
  app: {
    version: EAppVersion,
    step: number, 
    subStep: number,
    isLoading: boolean, 
    back: string, 
    offerDate: string, 
    expiry: string, 
    offerId: number
  }
}

export type AppActionTypes = SetAppAction
